export default __webpack_public_path__ + "static/media/customize-icon.70ee0d2d.svg";